import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaLeaf, FaUsers, FaArrowRight } from 'react-icons/fa';

export default function LandingPage() {
  const navigate = useNavigate();

  return (
    <div style={{ background: 'linear-gradient(135deg, #f0fdf4 0%, #dcfce7 50%, #f9fafb 100%)', minHeight: '100vh' }}>
      {/* Navbar */}
      <nav style={{
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        padding: '16px 60px', background: 'rgba(255,255,255,0.9)',
        backdropFilter: 'blur(10px)', borderBottom: '1px solid #dcfce7',
        position: 'sticky', top: 0, zIndex: 100
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
          <img
            src="/logo.png"
            alt="Sri Karunasai Logo"
            style={{
              width: 50, height: 50,
              borderRadius: '50%',
              objectFit: 'contain',
              boxShadow: '0 4px 12px rgba(22,163,74,0.25)',
              background: 'white'
            }}
          />
          <div>
            <div style={{ fontFamily: 'Poppins, sans-serif', fontWeight: 800, fontSize: 15, color: '#111827', lineHeight: 1.2 }}>
              Sri Karunasai
            </div>
            <div style={{ fontSize: 11, color: '#16a34a', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.05em' }}>
              Medicinal Plantation Association
            </div>
          </div>
        </div>

      </nav>

      {/* Hero Section */}
      <div style={{ maxWidth: 900, margin: '0 auto', padding: '80px 40px 60px', textAlign: 'center' }}>
        <div style={{
          display: 'inline-flex', alignItems: 'center', gap: 8,
          background: 'white', border: '1px solid #bbf7d0', color: '#15803d',
          padding: '6px 18px', borderRadius: 20, fontSize: 13, fontWeight: 600,
          marginBottom: 28, boxShadow: '0 2px 8px rgba(22,163,74,0.1)'
        }}>
          <FaLeaf size={12} /> Official Membership Portal
        </div>

        <h1 style={{
          fontFamily: 'Poppins, sans-serif', fontSize: 'clamp(2rem, 5vw, 3.6rem)',
          fontWeight: 800, color: '#111827', lineHeight: 1.15, marginBottom: 20
        }}>
          Sri Karunasai <span style={{ color: '#16a34a' }}>Medicinal</span>
          <br />Plantation Association
        </h1>

        <p style={{ fontSize: 17, color: '#6b7280', lineHeight: 1.8, marginBottom: 40, maxWidth: 600, margin: '0 auto 40px' }}>
          Empowering communities through sustainable medicinal plant cultivation. 
          Join our association and be part of a green revolution for health and prosperity.
        </p>

        <div style={{ display: 'flex', gap: 16, justifyContent: 'center', flexWrap: 'wrap' }}>
          <button className="btn btn-primary btn-lg" onClick={() => navigate('/user/login')}>
            <FaUsers size={16} /> Member Portal <FaArrowRight size={14} />
          </button>
        </div>

        {/* Stats Row */}
        <div style={{ display: 'flex', gap: 40, justifyContent: 'center', marginTop: 60 }}>
          {[
            { label: 'Active Members', value: '500+' },
            { label: 'Districts Covered', value: '12+' },
            { label: 'Plant Species', value: '200+' },
            { label: 'Years of Service', value: '15+' },
          ].map((s, i) => (
            <div key={i} style={{ textAlign: 'center' }}>
              <div style={{ fontSize: 28, fontWeight: 800, color: '#16a34a', fontFamily: 'Poppins, sans-serif' }}>{s.value}</div>
              <div style={{ fontSize: 13, color: '#6b7280', fontWeight: 500 }}>{s.label}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Features Grid */}
      <div style={{ maxWidth: 1100, margin: '0 auto', padding: '0 40px 80px' }}>
        <h2 style={{ textAlign: 'center', fontFamily: 'Poppins, sans-serif', fontSize: 28, fontWeight: 700, color: '#111827', marginBottom: 40 }}>
          Why Join Our Association?
        </h2>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: 24 }}>
          {[
            {
              icon: '🌱', title: 'Medicinal Cultivation Support',
              desc: 'Expert guidance on growing and harvesting medicinal plants with maximum yield and quality.'
            },
            {
              icon: '👨‍👩‍👧‍👦', title: 'Strong Community Network',
              desc: 'Connect with thousands of farmers and medicinal plant enthusiasts across Karnataka.'
            },
            {
              icon: '📋', title: 'Easy Registration',
              desc: 'Simple online registration process with quick approval and member ID generation.'
            },
            {
              icon: '💬', title: 'Direct Communication',
              desc: 'Real-time chat support with admin team for all your queries and assistance.'
            },
            {
              icon: '🛡️', title: 'Secure Platform',
              desc: 'Your personal information is protected with industry-standard security protocols.'
            },
            {
              icon: '📊', title: 'Transparent Management',
              desc: 'Full visibility into your membership status and association activities.'
            },
          ].map((f, i) => (
            <div key={i} className="feature-card">
              <div className="feature-icon">{f.icon}</div>
              <h3 style={{ fontWeight: 700, marginBottom: 8, color: '#1f2937', fontSize: 16 }}>{f.title}</h3>
              <p style={{ fontSize: 14, color: '#6b7280', lineHeight: 1.6 }}>{f.desc}</p>
            </div>
          ))}
        </div>
      </div>

      {/* CTA Section */}
      <div style={{
        background: 'linear-gradient(135deg, #15803d, #16a34a)',
        padding: '60px 40px', textAlign: 'center', color: 'white'
      }}>
        <h2 style={{ fontFamily: 'Poppins, sans-serif', fontSize: 28, fontWeight: 700, marginBottom: 16 }}>
          Ready to Join Our Green Community?
        </h2>
        <p style={{ fontSize: 16, opacity: 0.9, marginBottom: 32 }}>
          Contact your nearest association office for membership registration.
        </p>
        <div style={{ display: 'flex', gap: 12, justifyContent: 'center' }}>
          <button onClick={() => navigate('/user/login')} style={{
            padding: '12px 28px', background: 'white', color: '#15803d',
            border: 'none', borderRadius: 10, fontWeight: 700, cursor: 'pointer', fontSize: 15,
            display: 'flex', alignItems: 'center', gap: 8
          }}>
            <FaUsers /> Member Login
          </button>
        </div>
      </div>

      {/* Footer */}
      <footer style={{ background: '#1f2937', color: '#9ca3af', padding: '24px 60px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: 13 }}>
        <div>© 2024 Sri Karunasai Medicinal Plantation Association. All rights reserved.</div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
          <FaLeaf color="#16a34a" /> Karnataka, India
        </div>
      </footer>
    </div>
  );
}
